<div class="error">
    <img class="icon" src="/assets/img/icons/error/server.svg" *ngIf="error === 500" />
    <img class="icon" src="/assets/img/icons/error/forbidden.svg" *ngIf="error === 401" />
    <img class="icon" src="/assets/img/icons/error/sad.svg" *ngIf="error !== 401 && error !== 500" />
    <h2 class="text" *ngIf="error !== 401 && error !== 204">Algo ha fallado</h2>
    <h2 class="text" *ngIf="error === 401">No tienes acceso a este panel</h2>
    <h2 class="text" *ngIf="error === 204">No existen datos</h2>
    <h2 class="text">Error {{ error }}</h2>
</div>